import axios from 'axios';
import {
  KEY_ACCESS_TOKEN,
  KEY_LOGIN_ACCESS_TOKEN,
  configUrl,
  examModuleURL,
  KEY_ACCESS_TOKENS,
  ACCESS_TOKEN,
  INSTITUTE_NAME,
  KEY_REFRESH_TOKEN,
  REFRESH_URL,
} from './constants';
import UrlEndPoints from './urlEndPoint.json';
import moment from 'moment';
import { logOut } from './helper/storageHelper';
import history from './history';

let appConfig;

export let axiosInstance;
export let etlAxiosInstance;
let integrationInstance;

const getInsConfig = (config = appConfig) => {
  return config;
};

export const getAxiosInstance = (data) => {
  if (axiosInstance) {
    return axiosInstance;
  }
  appConfig = data.config;
  console.log('appConfig ', appConfig);
  axiosInstance = axios.create({
    baseURL: `${appConfig.apiBaseUrl}`,
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    req.headers['access-token'] = localStorage.getItem(KEY_LOGIN_ACCESS_TOKEN);
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      if (localStorage.refresh_token) {
        const url = REFRESH_URL;
        let access_token = localStorage.getItem('access_token');
        const instance = await getIntegrationInstance();
        try {
          const res = await instance.post(
            url,
            {
              refreshToken: localStorage.refresh_token,
            },
            {
              headers: {
                Authorization: `Bearer ${access_token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            }
          );
          localStorage.setItem(
            KEY_LOGIN_ACCESS_TOKEN,
            res?.data?.accessToken?.token
          );
          localStorage.setItem(
            KEY_REFRESH_TOKEN,
            res?.data?.refreshToken?.token
          );
        } catch (err) {
          logOut(history);
          // history.push('/');
        }
      }

      var config = {
        method: 'get',
        baseURL: `${appConfig.tokenUrl}`,
      };
      return axios(config).then(function (response) {
        localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
        if (error.response != undefined) {
          error.response.config.headers[
            'Authorization'
          ] = `Bearer ${response.data.access_token}`;
          return axios(error.response.config);
        }
      });
    }
  );
  return axiosInstance;
};

//etl
export const getETLAxiosInstance = async (data) => {
  appConfig = await getInsConfig(data[0].config);
  etlAxiosInstance = axios.create({
    baseURL: `${appConfig.etlBaseUrl}`,
    timeout: 15000,
  });

  etlAxiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    req.headers['access-token'] = localStorage.getItem(KEY_LOGIN_ACCESS_TOKEN);
    return req;
  });

  //Response interceptor for API calls
  etlAxiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      var config = {
        method: 'get',
        // baseURL: `${appConfig.apiBaseUrl}/token?grant_type=client_credentials`,
        // headers: {
        //   Authorization: `Basic ${appConfig.tokenHeader}`,
        // },
        baseURL: `${appConfig.tokenUrl}`,
      };
      return axios(config).then(function (response) {
        localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
        if (error.response != undefined) {
          error.response.config.headers[
            'Authorization'
          ] = `Bearer ${response.data.access_token}`;
          return axios(error.response.config);
        }
      });
    }
  );
};

// LMS

export const getIntegrationInstance = async () => {
  console.log('Integration: appCOnfig ', appConfig);
  if (integrationInstance) {
    return integrationInstance;
  }
  integrationInstance = axios.create({
    baseURL: `${appConfig.integrationUrl}`,
    timeout: 15000,
  });

  integrationInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    req.headers['access-token'] = localStorage.getItem(KEY_LOGIN_ACCESS_TOKEN);
    return req;
  });

  //Response interceptor for API calls
  integrationInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      var config = {
        method: 'get',
        baseURL: `${appConfig.tokenUrl}`,
      };
      return axios(config).then(function (response) {
        localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
        error.response.config.headers[
          'Authorization'
        ] = `Bearer ${response.data.access_token}`;
        return axios(error.response.config);
      });
    }
  );
  return integrationInstance;
};

export const createQuiz = async (data) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.export_quiz_questions}`,
    {
      method: 'get',
      courseoffering: data,
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

//

export const sendMail = async (data) => {
  const path = `${UrlEndPoints.email}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const sendSMS = async (data) => {
  const path = `${UrlEndPoints.sms}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const getcoursebyprogramplan = async (id) => {
  const path = `${UrlEndPoints.getcoursebyprogramplan}`;
  const res = await axiosInstance.get(`${appConfig.apiBaseUrl}/${path}/${id}`);
  return res && res.data ? res.data : null;
};

export const getProgramPlan = async (id) => {
  const path = `${UrlEndPoints.programPlan}`;
  const res = await axiosInstance.get(`${appConfig.apiBaseUrl}/${path}/${id}`);
  return res && res.data ? res.data : null;
};

export const postNotification = async (data) => {
  const path = `${UrlEndPoints.notify}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const getAcademicProgram = async (id) => {
  const path = `${UrlEndPoints.academicProgram}`;
  const res = await axiosInstance.get(`${appConfig.apiBaseUrl}/${path}/${id}`);
  return res && res.data ? res.data : null;
};

export const getInstituteDetails = async (id) => {
  const path = `${UrlEndPoints.instituteAccount}`;
  const res = await axiosInstance.get(
    `${appConfig.instituteUrl}/${path}/${id}`
  );
  return res && res.data ? res.data : null;
};

//----------------------------------Time Table--------------------------------------------

//get all institutes
// Please refer getInstituteByTypeAndInstitute

//get master timetable
export const getMasterTimetable = async (date, id) => {
  if (date instanceof Date) {
    date = moment(date).format('YYYY-MM-DD');
  }
  const path = `${UrlEndPoints.masterTimetable}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${date}/${id}`
  );
  return res && res.data ? res.data : null;
};

//get all time blocks
export const getAllTimeBlocks = async (instituteId) => {
  const path = `${UrlEndPoints.allTimeBlocks}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${instituteId}`
  );
  return res && res.data ? res.data : null;
};

//Delete schedule (subject/class)
export const deleteSchedule = async (scheduleId) => {
  const path = `${UrlEndPoints.schedule}`;
  const res = await axiosInstance.delete(
    `${appConfig.adminUrl}/${path}/${scheduleId}`
  );
  return res && res.data ? res.data : null;
};

// create schedule
export const createSchedule = async (data) => {
  const path = `${UrlEndPoints.schedule}`;
  const res = await axiosInstance.post(`${appConfig.adminUrl}/${path}`, data);
  return res && res.data ? res.data : null;
};

//get all course offerings
export const getAllCourses = async (date, id) => {
  if (date instanceof Date) {
    date = moment(date).format('YYYY-MM-DD');
  }
  const path = `${UrlEndPoints.courseoffering}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${date}/${id}`
  );
  return res && res.data ? res.data : null;
};

export const getAllCourse = async (contactId, programId) => {
  const res = await axiosInstance.get(
    `${UrlEndPoints.getallcourse}/${contactId}/${programId}`
  );
  return res && res.data ? res.data : null;
};
//-------------------------------------------------------------------------------------------
export const getConfig = async () => {
  // const path = 'sp-jain-stg-adminportal.ken42.com';
  const path = 'flame-stg-adminportal.ken42.com';
  const res = await axios.get(`${configUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getJobDetails = async (instituteId) => {
  const path = `${UrlEndPoints.jobDetails}`;
  const res = await etlAxiosInstance.get(
    `${appConfig.etlBaseUrl}${path}/${instituteId}`
  );
  return res && res.data ? res.data : null;
};

export const getSubJobDetails = async (instituteId, jobId) => {
  const path = `${UrlEndPoints.jobDetails}`;
  const res = await etlAxiosInstance.get(
    `${appConfig.etlBaseUrl}${path}/${instituteId}/${jobId}`
  );
  console.log(res?.data, 'subJobDetails....');
  return res && res.data ? res.data : null;
};

export const createJob = async (upload) => {
  const path = `${UrlEndPoints.jobDetails}`;
  const res = await etlAxiosInstance.post(
    `${appConfig.etlBaseUrl}${path}`,
    upload.data,
    {
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
    }
  );
  console.log(res, 'response of create job');
  return res && res.data ? res.data : null;
};

export const getErrorLog = async (error, jobId) => {
  const path = `${UrlEndPoints.errorLog}`;
  const res = await etlAxiosInstance.get(
    `${appConfig.etlBaseUrl}/${path}/${jobId}`
  );
  console.log(res?.data, 'subJobDetails....');
  return res && res.data ? res.data : null;
};

export const postStorageDb = async (data) => {
  const path = `${UrlEndPoints.create}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const createEvents = async (payload) => {
  const path = `${UrlEndPoints.event}`;
  const res = await axiosInstance.post(
    `${appConfig.adminUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};
export const getAccountData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  console.log('axiosInstance', axiosInstance);
  const query = encodeURIComponent(`/services/data/v54.0/sobjects/Account`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getEvents = async (payload) => {
  const path = `${UrlEndPoints.events}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const updateEvent = async (payload) => {
  const path = `${UrlEndPoints.event}`;
  const res = await axiosInstance.put(`${appConfig.adminUrl}/${path}`, payload);
  return res && res.data ? res.data : null;
};

export const deleteEvent = async (eventId) => {
  const path = `${UrlEndPoints.event}`;
  const res = await axiosInstance.delete(
    `${appConfig.adminUrl}/${path}/${eventId}`
  );
  return res && res.data ? res.data : null;
};

export const getSmsTemplates = async () => {
  const path = `${UrlEndPoints.smsTemplates}`;
  const res = await axiosInstance.get(`${appConfig.adminUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const sendBulkSMS = async (payload) => {
  const path = `${UrlEndPoints.sms}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const sendBulkMail = async (payload) => {
  const path = `${UrlEndPoints.email}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const gradeWiseSms = async (payload) => {
  const path = `${UrlEndPoints.gradeWiseSms}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const gradeWiseMail = async (payload) => {
  const path = `${UrlEndPoints.gradeWiseEmail}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const getInstituteByTypeAndInstitute = async (type, value) => {
  const path = `${UrlEndPoints.institute}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${type}/${value}`
  );
  return res && res.data ? res.data : null;
};

// export const getDeprtmentists = async (instituteId) => {
//   const path = `${UrlEndPoints.getDeptURL}`;
//   const res = await axiosInstance.get(`${appConfig.adminUrl}/${path}/${instituteId}`);
//   return res && res.data ? res.data : null;
// };

export const postSubjects = async (data) => {
  const path = `${UrlEndPoints.schedule}`;
  const res = await axiosInstance.put(`${appConfig.adminUrl}/${path}`, data);
  return res && res.data ? res.data : null;
};

export const getEventRegisterList = async (eventId, contactId) => {
  const path = `${UrlEndPoints.eventDetails}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${eventId}`
  );
  return res && res.data ? res.data : null;
};

export const sendDynamicMail = async (payload) => {
  const path = `${UrlEndPoints.dynamicEmail}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const imageUpload = async (payload) => {
  const path = `${UrlEndPoints.imageUpload}`;
  const res = await etlAxiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload,
    {
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
    }
  );
  return res && res.data ? res.data : null;
};

export const getInstitutes = async () => {
  const path = `${UrlEndPoints.institutes}/0`;
  const res = await axiosInstance.get(`${appConfig.adminUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getFilterContacts = async (educationInstitution) => {
  const path = `${UrlEndPoints.filterContacts}&educationInstitution=${educationInstitution}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getRoleTypes = async () => {
  const path = `${UrlEndPoints.roleTypes}`;
  const res = await axiosInstance.get(`${appConfig.adminUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getAcademicProgramByInstituteId = async (instituteId) => {
  const path = `${UrlEndPoints.academicProgramByInstituteId}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${instituteId}`
  );
  return res && res.data ? res.data : null;
};

export const getProgramPlanByAcademicProgramId = async (academicId) => {
  const path = `${UrlEndPoints.programPlanByAcademicProgramId}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${academicId}`
  );
  return res && res.data ? res.data : null;
};

export const getClassSectionByProgramPlanId = async (programId) => {
  const path = `${UrlEndPoints.classSectionByProgramPlanId}`;
  const res = await axiosInstance.get(
    `${appConfig.adminUrl}/${path}/${programId}`
  );
  return res && res.data ? res.data : null;
};

export const postAssignRole = async (data) => {
  const path = `${UrlEndPoints.assignRole}`;
  const res = await axiosInstance.post(`${appConfig.adminUrl}/${path}`, data);
  return res && res.data ? res.data : null;
};

export const getBatchFilter = async (querry) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/CurrentPageFilter/?${querry}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getCurrentBatch = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/CurrentPageFilter/?termStatus=${filterData.termStatus}&campus=${filterData.campus}&intake=${filterData.intake}&program=${filterData.program}&batch=${filterData.batch}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getAcademicFilter = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/AcademicProgramsName`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getCourseVersionsByFacility = async (querry) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/courseVersionsByFacility/?${querry}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getProgramAndTermCampusCombinationBYAcademicProgramId = async (
  AcademicProgramId
) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/programAndTermCampusCombination/?AcademicProgramId=${AcademicProgramId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getNoofSpecialization = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SpecializationsByProgram/?academicProgramId=${id}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postNoofSpecialization = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SpecializationsByProgram`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const getPromotionCriteriaDataFilter = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/PromotionCriteriaData`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getAddPromotionCriteriaDataFilter = async (promotionFilter) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CriteriaWithFilterData/?recordType=Master&criteriaType=${promotionFilter}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getAddPromotionCriteriaData = async (promotionFilter, data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/createCriteriaWithFilter`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const getPromotionCriteriaData = async (promotionFilter) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CriteriaWithFilterData/?recordType=Default&criteriaType=${promotionFilter}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getstudentPromotionCriteriaData = async (
  programId,
  termFilter,
  criteria
) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CriteriaWithFilterData/?programId=${programId}&recordType=Default&criteriaType=${criteria}&termId=${termFilter}
`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getSinglPromotionCriteriaData = async (
  promotionFilter,
  criteriaId,
  AcademicProgramId,
  TermNumber
) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CriteriaWithFilterData/?recordType=Default&criteriaType=${promotionFilter}&criteriaId=${criteriaId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postProgramBatchSpecialization = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createProgramBatchSpecialization`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getFacilityBookedSlots = async ({
  facilityBookingId = '',
  facilityId = '',
  academicPlannerActivityId = '',
}) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacilityBookingData?facilityBookingId=${facilityBookingId}&facilityId=${facilityId}&academicPlannerActivityId=${academicPlannerActivityId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getFacultyBookingsData = async ({
  facultyBookingId = '',
  facultyId = '',
  academicPlannerActivityId = '',
}) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacultyBookingsData?facultyBookingId=${facultyBookingId}&facultyId=${facultyId}&academicPlannerActivityId=${academicPlannerActivityId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getAcademicPlannerSession = async (termId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/AcademicPlannerData/?term=${termId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getSessionData = async ({
  term = '',
  facilityId = '',
  facultyId = '',
}) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SessionData/?termId=${term}&facilityId=${facilityId}&facultyId=${facultyId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const sessionCUD = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/createSession`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};

export const getBookedSlotById = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacilityBookingData/?facilityBookingId=${id}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getBookedSlotDelete = async (deleteData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createFacilityFacultyBooking`
  );
  const res = await axiosInstance.post(`${path}${query}`, deleteData);
  return res && res.data ? res.data : null;
};

export const createBookedSlot = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createFacilityFacultyBooking`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const getFaciltyAvailableData = async (startDate, endDate) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacilityFacultyAvailableData/?startDate=${startDate}&endDate=${endDate}`
  );
  console.log('datecheck===', startDate, endDate);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getAllFacultyFacilitySubject = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacilityFacultyBookingData/?academicPlannerActivityId=${id}`
  );

  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

// /services/apexrest/FacilityFacultyBookingData/?academicPlannerActivityId=a2R6D000000leF2UAI

export const getTermData = async (filter) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/CurrentPageFilter/?intake=${filter.intake}&program=${filter.program}&batch=${filter.year}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getCourseVersion = async (term) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/CourseVersionData/?term=${term}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getReferenceApi = async (term) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/ActivitiesData/?programName=&intake=&year=&campus=&term=${term}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getReferenceApiExam = async (term) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/ActivitiesData/?programName=&intake=&year=&campus=&term=${term}&type=Exam`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const addEventForBook = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/CreateActivities`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const updateReferenceActivities = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/createActivities`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getFacultyAndFacilty = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/FacilityFacultyAllData`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getAcademicPlannerData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/AcademicPlannerData/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postAcademicPlanner = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createAcademicPlannerActivity`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getCourseVersionData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/CourseVersionData/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
// export const postAcademicPlanner = async (data) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(
//     `services/apexrest/createAcademicPlannerActivity`
//   );
//   const res = await axiosInstance.post(`${path}${query}`, data);
//   return res && res.data ? res.data : null;
// };
// export const getCourseVersionData = async (data) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(
//     `services/apexrest/CourseVersionData/${data}`
export const postCourseVersionData = async (data) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/createCourseVersion`
  )}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const postMasterSubjects = async (data) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/MasterSubjects`
  )}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const getMasterActivityWithTermData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/MasterActivityWithTermData/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getImportTermActivity = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/importTermActivity/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

// ------------------------------------------- Exam Module ------------------------------------------------------//

export const postExamData = async () => {
  // const path = `https://test.salesforce.com/services/oauth2/token?username=implementations@ken42.spj.playground&password=Test@12345&grant_type=password&client_id=3MVG9z6NAroNkeMnubhGFikwXGxGnnX7J._ggYGGzJBVcxC0wwW3luRx4bhwdRxUdm3ZSkpxh_aCE5L7empGD&client_secret=7913691316DB84DF20A53FA2037AF622FD813C589505E1E7CE4310F84CAF7E0A`;

  // const res = await axios.get(`${path}`);
  // test
  const axiosInstances = await axios.post(
    `https://test.salesforce.com/services/oauth2/token?username=implementations@ken42.spj.playground&password=Test@123456&grant_type=password&client_id=3MVG9z6NAroNkeMnubhGFikwXGxGnnX7J._ggYGGzJBVcxC0wwW3luRx4bhwdRxUdm3ZSkpxh_aCE5L7empGD&client_secret=7913691316DB84DF20A53FA2037AF622FD813C589505E1E7CE4310F84CAF7E0A`
  );

  localStorage.setItem('access_tokensss', axiosInstances.data.access_token);

  return axiosInstance;
};
export const getExamData = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/ExamData?dueDays=${filterData.pendingDueDate}&completedIn=${filterData.comduedays}`
  );
  const res = await axiosInstance.get(`${path}${query}`);

  return res && res.data ? res.data : null;
};

export const getStudentRiskDataData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/StudentRiskData`);
  const res = await axiosInstance.get(`${path}${query}`);

  return res && res.data ? res.data : null;
};

// export const getStudentStatusData = async (filterData) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(
//     `services/apexrest/StudentData/?filter=${filterData.filter}&campus=${filterData.campus}&course=${filterData.course}&eligibilityStatus=${filterData.eligibilityStatus}&reason=${filterData.reason}&nameOrRollNum=${filterData.nameOrRollNum}&batch=${filterData.batch}&examCycle=${filterData.examCycle}&pageNo=${filterData.pageNo}&count=${filterData.count}&Programe=${filterData.Programe}&status=Ongoing`
//   );
//   const res = await axiosInstance.get(`${path}${query}`);

//   return res && res.data ? res.data : null;
// };

export const getStudentStatusWithoutParaData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/StudentData`);
  const res = await axiosInstance.get(`${path}${query}`);

  return res && res.data ? res.data : null;
};
export const postStudentStatusData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/StudentData`);
  const res = await axiosInstance.post(`${path}${query}`, data);

  return res && res.data ? res.data : null;
};

// export const postQuestionPaperData = async (data) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(`/services/apexrest/QuestionPaper`);
//   const res = await axiosInstance.post(`${path}${query}`, data);

//   return res && res.data ? res.data : null;
// };

export const getSeatingPlanData = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/TimeTable?course=${filterData.course}&termName=${filterData.termName}&duration=${filterData.duration}&examType=${filterData.examType}&batch=${filterData.batch}&examCycle=${filterData.examCycle}&pageNo=${filterData.pageNo}&count=${filterData.count}&status=Ongoing`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getSeatingPlanData1 = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/TimeTable`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getEvaluationDetailsData = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/EvaluationDetails?course=${filterData.course}&deadline=${filterData.deadline}&dateOfExam=${filterData.dateOfExam}&subjectFaculty=${filterData.subjectFaculty}&allocatedTo=${filterData.allocatedTo}&status=${filterData.status}&batch=${filterData.batch}&examCycle=${filterData.examCycle}&pageNo=${filterData.pageNo}&count=${filterData.count}&evaluationstatus=Ongoing`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postEvaluationDetailsData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/EvaluationDetails`);
  const res = await axiosInstance.post(`${path}${query}`, data);

  return res && res.data ? res.data : null;
};

export const getInvigilator_s1_Data = async (filter) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/TimeTable?termName=${filter.termName}&course=${filter.course}&date=${filter.date}&duration=${filter.duration}&examType=${filter.examType}&batch=${filter.batch}&examCycle=${filter.examCycle}&pageNo=${filter.pageNo}&count=${filter.count}&status=Ongoing`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getInvigilator_s1_Datas = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/EvaluatorDetails`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postInvigilator_s1_Data = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/TimeTable`);
  const res = await axiosInstance.post(`${path}${query}`, data);

  return res && res.data ? res.data : null;
};

export const getInvigilator_s2_Data = async (filter) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/InvigilatorsList/?examId=${filter.id}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

// For Eval
export const getEvaluator_s2_Data = async (filter) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/EvaluatorsList/?examId=${filter.id}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getEvaluation_s2_Data = async (filter) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/EvaluatorDetails/?examId=${filter.id}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postEval_s2_Data = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/EvaluatorDetails`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};

export const getGradingData = async (CourseOfferingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/Componentdata?StudentId=${CourseOfferingId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

// export const postInvigilator_s2_Data = async (data) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(`/services/apexrest/InvigilatorDetails`);
//   const res = await axiosInstance.post(`${path}${query}`, data);

//   return res && res.data ? res.data : null;
// };

export const getMasterSubjectsWithTermData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/MasterSubjectsWithTermData/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getImportTermwiseSubjectData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/importTermSubjects/${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postCreateCourseVersionsAndActivites = async (payload) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/createCourseVersionsAndActivites`
  )}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};
export const postSeatingPlanData = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/TimeTable`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};
export const getSeatingArrangement = async (examId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SeatingDetails?examId=${examId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getFacilityData = async (examID) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/FacilityData?examId=${examID}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getInviligilation = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/RetestRevaluationDetails?type=Revaluation`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getAnswer = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/RetestRevaluationDetails?type=Answer Sheet`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postFacilityData = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/FacilityData`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};

export const getRetestData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/RetestRevaluationDetails`
  );
  const res = await axiosInstance.get(`${path}${query}?type=Retest`);
  return res && res.data ? res.data : null;
};

export const getRevalData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/RetestRevaluationDetails`
  );
  const res = await axiosInstance.get(`${path}${query}?type=Revaluation`);
  return res && res.data ? res.data : null;
};

export const postRetestData = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/RetestRevaluationDetails`
  );
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};

export const postInvigilator_s2_Data = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/InvigilatorsList`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};
export const postEvaluation_s2_Data = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/EvaluationsList`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};
export const getFacilityBookingDetails = async (examId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacilityBookingDetails?examId=${examId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postSeatingArrangement = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/SeatingDetails`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};
export const getStudentExamRoom = async (examId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/StudentExamRoom?examId=${examId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getpdfdata = async (questionPaperId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/QuestionPaperForExam?questionPaperId=${questionPaperId}`
  );
  const res = await axiosInstance.get(`${path}${query}`, {
    // responseType: 'blob',
    // contentType: 'application/pdf',
  });

  console.log('resresresresresresres', res);
  return res && res.data ? res.data : null;
};
export const filterSessionGetData = async (courseOfferingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SessionData/?courseOfferingId=${courseOfferingId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getSectionOfferingData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/CourseOfferingData/?${data}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postSectionOfferingData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/createCourseOffering`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const filterSessionAddData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/createSessionFeedbackSetup`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const filterSessionDeleteData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/createSessionFeedbackSetup`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const postPdfQuestionPaperData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/QuestionPaperForExam`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

// grading api
export const getGradingCourseDetails = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/GradingCourseDetails?course=${filterData.course}&status=${filterData.status}&term=${filterData.term}&faculty=&batch=${filterData.batch}&examCycle=${filterData.examCycle}&campus=${filterData.campus}&pageNo=${filterData.pageNo}&count=${filterData.count}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getGradingDetails = async (gradingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SubjectScores?courseOfferingId=${gradingId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getGradingDetailsByStudentId = async (StudentId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SubjectScores?studentId=${StudentId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

// Enrollment - Student
export const getDataForTermEnrolment = async (instituteId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/getDataForTermEnrolment?instituteId=${instituteId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getStudentScoreDataGraph = async (gradingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/StudentScoreData?gradingId=${gradingId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getStudentDataForTermEnrolment = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/getStudentDataForTermEnrolment?academicProgramId=${payload.academicProgramId}&instituteId=${payload.instituteId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getExamModuleListData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/ExamModuleList`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getEvaluationMasterDatas = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/EvaluationComponentSettings?instituteName=${INSTITUTE_NAME}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
// export const getEvaluationMasterData = async () => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(
//     `/services/apexrest/EvaluationMasterData?instituteName=${INSTITUTE_NAME}`
//   );
//   const res = await axiosInstance.get(`${path}${query}`);
//   return res && res.data ? res.data : null;
// };
export const getDataForCourseEnrolment = async (instituteId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/getDataForCourseEnrolment?instituteId=${instituteId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getDataForStudentEnrolment = async (
  academicProgramId,
  termId,
  programPlanId,
  criteria
) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  let query = '';
  if (criteria === 'Graduation') {
    query = encodeURIComponent(
      `/services/apexrest/StudentOnFormulaData/?academicProgramId=${academicProgramId}&programPlanId=${programPlanId}&criteriaType=${criteria}`
    );
  } else {
    query = encodeURIComponent(
      `/services/apexrest/StudentOnFormulaData/?academicProgramId=${academicProgramId}&termId=${termId}&programPlanId=${programPlanId}&criteriaType=${criteria}`
    );
  }
  // const query = encodeURIComponent(
  //   `/services/apexrest/StudentOnFormulaData/?academicProgramId=0011y00000P7qGHAAZ&termId=a0P1y000001J92OEAS&programPlanId=a0K1y000002MGukEAG&criteriaType=Term+Promotion`
  // );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getStudentAndCourseForEnrolment = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/getStudentAndCourseForEnrolment?academicProgramId=${payload.academicProgramId}&instituteId=${payload.instituteId}&sectionName=${payload.sectionName}&termId=${payload.termId}&specializationId=${payload.specializationId}&searchedName=${payload.searchedName}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getStudentListByCourseOffering = async (courseId) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/studentsByCourseOffering?CourseOfferingId=${courseId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const postEvaluationMasterDatas = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/EvaluationComponentSettings`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const postEnrolmentTillCourses = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createEnrolmentTillCourses`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getDefaultGradeRangerDatas = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CreateDefaultGradeRange?instituteName=${INSTITUTE_NAME}`
  );

  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getAcademicCalendar = async (termId) => {
  const path = `${appConfig.integrationUrl}/sf/getData?api=`;
  const query = encodeURIComponent(`AcademicCalendar?${termId}`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getAcademicCalendarNew = async (querry) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/AcademicCalendar${querry}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const postDefaultGradeRangerDatas = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CreateDefaultGradeRange`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const postGradingDetailsScreenDatas = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/GradingDetails`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

// export const updateReferenceActivities = async (data) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(`/services/apexrest/createActivities`);
//   const res = await axiosInstance.post(`${path}${query}`, data);
//   return res && res.data ? res.data : null;
// };
// export const getReferenceApi = async (term) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(
//     `/services/apexrest/ActivitiesData/?programName=&intake=&year=&campus=&term=${term}`
//   );
//   const res = await axiosInstance.get(`${path}${query}`);
//   return res && res.data ? res.data : null;
// };
// export const getFacilityBookedSlots = async ({
//   facilityBookingId = '',
//   facilityId = '',
//   academicPlannerActivityId = '',
// }) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(
//     `services/apexrest/FacilityBookingData?facilityBookingId=${facilityBookingId}&facilityId=${facilityId}&academicPlannerActivityId=${academicPlannerActivityId}`
//   );
//   const res = await axiosInstance.get(`${path}${query}`);
//   return res && res.data ? res.data : null;
// };
// export const getFacultyBookingsData = async ({
//   facultyBookingId = '',
//   facultyId = '',
//   academicPlannerActivityId = '',
// }) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(
//     `services/apexrest/FacultyBookingsData?facultyBookingId=${facultyBookingId}&facultyId=${facultyId}&academicPlannerActivityId=${academicPlannerActivityId}`
//   );
//   const res = await axiosInstance.get(`${path}${query}`);
//   return res && res.data ? res.data : null;
// };
export const postAcademicCalendar = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=/services/apexrest/AcademicCalendar/`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const postValidateSession = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/validateSession`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const validateSubcomponentScores = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/validateSubcomponentScores`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const postCreateSession = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/createSession`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getCourseOfferingByCourseAndTerm = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CourseOfferingByCourseAndTerm?CourseId=${payload.CourseId}&TermId=${payload.TermId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getFacultyList = async (querry) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/FacultyList/${querry}`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postFacultyEnrollment = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/FacultyEnrollment`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getCreateGradeRange = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CreateDefaultGradeRange`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getCourseEvaluationComponent = async (filterData) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CourseEvaluationComponent?courseName=${filterData.courseName}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getCourseEvaluationComponentByCourseOfferingId = async (
  SectionId
) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CourseEvaluationComponent?courseOfferingId=${SectionId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getCourseEvaluationSubcomponentByComponentId = async (
  ComponentId
) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CourseEvaluationSubcomponent?componentId=${ComponentId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getComponentScoreByComponentId = async (ComponentId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/ComponentScores?componentId=${ComponentId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getSubcomponentScoresBySubComponentId = async (SubComponentId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SubcomponentScores/?subcomponentId=${SubComponentId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getUserData = async (querry) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/users/${querry}`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

//get Additional InfoData
export const getAdditionalInfoData = async (contactId) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/ContactAdditionalInfoData/?contactId=${contactId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};
export const getFacultyHistoryInfoData = async (contactId) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/facultyFeedbackratingAverage?facultyId=${contactId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};
//delete Additional InfoData
export const deleteAdditionalInfoData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/createAdditionalInfo`);

  const newData = {
    Operation: 'Delete',
    AdditionalInformation: data,
  };
  const res = await axiosInstance.post(`${path}${query}`, newData);
  return res && res.data ? res.data : null;
};
export const createSubcomponentScores = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/createSubcomponentScores`
  );

  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const deleteStudentAddressInfo = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/getData?api=`;
  const query = encodeURIComponent(`Address/?recordId=${id}`);
  const res = await axiosInstance.delete(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const deleteEducationInfo = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/getData?api=`;
  const query = encodeURIComponent(`EducationHistoryApi/?recordId=${id}`);
  const res = await axiosInstance.delete(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getProfileImageData = async (courseOfferingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/ContactAttachment/?recordId=${courseOfferingId}&fileName=passportPhoto`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const saveStudentEducationInfo = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/EducationHistoryApi`);

  const res = await axiosInstance.post(`${path}${query}`, { records: data });
  return res && res.data ? res.data : null;
};

export const saveStudentProfileImage = async (data, contactId) => {
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  const path = `${appConfig.integrationUrl}`;
  const query = `/report/signature?programEnrollmentId=${contactId}&fileName=passportPhoto`;

  const res = await axiosInstance.post(`${path}${query}`, data, headers);
  return res && res.data ? res.data : null;
};

export const saveStudentAddressInfo = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/Address`);
  const newData = data.map((ele) => {
    return ele.add;
  });
  const res = await axiosInstance.post(`${path}${query}`, { records: newData });
  return res && res.data ? res.data : null;
};

export const saveResearchSuperVision = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/createAdditionalInfo`);
  const newData = {
    Operation: 'Create',
    AdditionalInformation: data,
  };
  const res = await axiosInstance.post(`${path}${query}`, newData);
  return res && res.data ? res.data : null;
};

export const saveStudentRelationInfo = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/Relationship`);

  const newData = data.map((ele) => {
    return ele.res;
  });
  const res = await axiosInstance.post(`${path}${query}`, { records: newData });
  return res && res.data ? res.data : null;
};
export const saveStudentProfileInfo = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/ContactDetail`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const saveFacultyAddressInfo = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/Address`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getStudentInfo = async (contactId) => {
  const res = await axiosInstance.get(
    `${appConfig.integrationUrl}/sf/data?api=services/apexrest/ContactDetail/${contactId}`
  );
  return res && res.data ? res.data : null;
};
export const getStudentDetails = async (contactId) => {
  const res = await axiosInstance.get(`/${UrlEndPoints.contact}/${contactId}`);
  return res && res.data ? res.data : null;
};
export const getTermsAndCourseVersions = async (querry) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/TermsAndCourseVersions?&programPlanId=${querry}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getActivitesWithCourseVersion = async (courseVersionId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/activitesWithCourseVersion?&courseVersionId=${courseVersionId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getFacultyDetails = async (academicProgramId) => {
  const res = await axiosInstance.get(
    `${UrlEndPoints.faculty}/${academicProgramId}`
  );
  return res && res.data ? res.data : null;
};

export const getDownGradingRulesSetup = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/DownGradingRulesSetup`);

  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postDownGradingRulesSetup = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/DownGradingRulesSetup`);

  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getStudentsMarksByCourseOffering = async () => {
  return [
    {
      contactName: 'Pranav',
      marksObtained: '90',
      maxMarks: 100,
      percentage: 90,
      grade: 'A+',
      penalty: '1',
      finalGrade: 'A',
      credits: 10,
      creditsEarned: 9,
      passStatus: 'Pass',
      components: [
        {
          criteria: 'Overview text like weightage in course 12F - 12I data ',
          name: 'Quiz',
          maxMarks: 10,
          marksObtained: 9,
          marksInCourse: 4.5, //If course weightage is 5%,
          subComponents: [
            {
              criteria: 'Overview text like weightage',
              name: 'Quiz 1',
              maxMarks: 5,
              marksObtained: 5,
            },
            {
              criteria: 'Overview text like weightage',
              name: 'Quiz 2',
              maxMarks: 5,
              marksObtained: 4,
            },
          ],
        },
        {
          name: 'Presentaion',
          maxMarks: 10,
          marksObtained: 9,
          marksInCourse: 9, //Course weightage is 10,
          // Subcomponents not required in case of 1 subcomponent only
        },
      ],
    },
    {
      contactName: 'Prashanth',
      marksObtained: '90',
      maxMarks: 100,
      percentage: 90,
      grade: 'A+',
      penalty: '1',
      finalGrade: 'A',
      credits: 10,
      creditsEarned: 9,
      passStatus: 'Pass',
      components: [
        {
          criteria: 'Overview text like weightage in course 12F - 12I data ',
          name: 'Quiz',
          maxMarks: 10,
          marksObtained: 9,
          marksInCourse: 4.5, //If course weightage is 5%,
          subComponents: [
            {
              criteria: 'Overview text like weightage 50%',
              name: 'Quiz 1',
              maxMarks: 10,
              marksObtained: 10,
            },
            {
              criteria: 'Overview text like weightage 50%',
              name: 'Quiz 2',
              maxMarks: 10,
              marksObtained: 9,
            },
          ],
        },
        {
          criteria: 'Overview text like weightage in course 12F - 12I data ',
          name: 'Presentaion',
          maxMarks: 10,
          marksObtained: 9,
          marksInCourse: 9, //Course weightage is 10,
          // Subcomponents not required in case of 1 subcomponent only ss
        },
      ],
    },
  ];
};

export const getCourseWithoutExam = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/CoursesWithoutExam`);
  const res = await axiosInstance.get(`${path}${query}`);

  return res && res.data ? res.data : null;
};

export const getCustomGrade = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/GradePointsSetup`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getEvaluationMasterData = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/EvaluationMasterData`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getSubjectScoresModeration = async (courseOfferingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/subjectScoresByCourseId?courseId=a2JO00000048RuyMAE`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getFacultyCourseAssociation = async (querry) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacultyCourseAssociation/?${querry}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getContactAllDetails = async (contactId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/contactAllDetails/${contactId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postCustomGradeSetup = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/GradePointsSetup`);

  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const updateAdminNotes = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/adminNotes`);
  const res = await axiosInstance.post(`${path}${query}`, payload);
  return res && res.data ? res.data : null;
};

export const getFacultyCourseAssociationSearch = async (querry) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/FacultyCourseAssociationSearch/${querry}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const deleteDowngradingRule = async (recordId) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/DownGradingRulesSetup?recordId=${recordId}`
  )}`;
  const res = await axiosInstance.delete(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const deleteGradePointsSetup = async (recordId) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/GradePointsSetup?recordId=${recordId}`
  )}`;
  const res = await axiosInstance.delete(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getCampusHolidaysData = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`services/apexrest/campusHolidays/${data}`);
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getPlannedData = async (querry) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/ActivitiesData/?${querry}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postDefualtGradeSetup = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/GradeAllocationSetup`);

  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const postSubjectDetails = async (data, CourseOfferingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/studentsSubject/?CourseOfferingId=${CourseOfferingId}`
  );

  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getGradingStatics = async (courseOfferingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SegregatedSubjectScores?courseOfferingId=${courseOfferingId}  `
  );

  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getGradingAck = async (state, gradingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SendEmailForMarks?state=${state}&comState=Ack&gradingId=${gradingId}  `
  );

  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const getGradingPublish = async (state, gradingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SendEmailForMarks?state=${state}&comState=Publish&gradingId=${gradingId}  `
  );

  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const publishExam = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/TimeTable`);
  const res = await axiosInstance.post(`${path}${query}`, data);

  return res && res.data ? res.data : null;
};

export const publishExamforInvigilation = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/EvaluationDetails`);
  const res = await axiosInstance.post(`${path}${query}`, data);

  return res && res.data ? res.data : null;
};

export const facultyList = async (state, gradingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/FacultyList`);

  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getFacultyAvailabilityBooking = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/facultyAvailabilityFacultyBooking/?facultyId=${id}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postTermDatesUpdate = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/TermDatesUpdate`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const singleExamDetails = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/examRecord?examId=${id}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const GradingSubComponent = async (CourseOfferingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/SubcomponentScoreData?CourseOfferingId=${CourseOfferingId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const GradingGet = async (CourseOfferingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/studentsSubject/?CourseOfferingId=${CourseOfferingId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postComponentdataDetails = async (StudentId, data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/Componentdata/?StudentId=${StudentId}`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const getMasterComponent = async (CourseOfferingId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CourseEvaluationComponentSubcomponent`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postMasterComponent = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CourseEvaluationComponentSubcomponent`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const deleteMasterComponent = async (componentId) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/CourseEvaluationComponentSubcomponent/?componentId=${componentId}`
  )}`;
  const res = await axiosInstance.delete(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const deleteMasterComponentData = async (componentId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CourseEvaluationComponentSubcomponent/&componentId=${componentId}`
  );
  const res = await axiosInstance.delete(`${path}${query}`);
  return res && res.data ? res.data : null;
};

// Login
export const requestForOTP = async (payload) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/AdminOtp/send?contact=${payload}`
  )}`;
  const res = await axiosInstance.post(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};
export const verifyOTP = async (payload) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/AdminOtp/verify?contact=${payload.id}&otpentered=${payload.otp}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};
export const getCourseEvalCompAndSubComp = async (querry) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/courseEvalCompAndSubComp${querry}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postCourseEvalCompAndSubComp = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/CourseEvaluationComponentSubcomponent`
  );
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};

export const deleteCourseEvaluationComponent = async (querry) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/CourseEvaluationComponentSubcomponent/${querry}`
  )}`;
  const res = await axiosInstance.delete(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};
export const getCourseComponents = async () => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/dropDownValuesForGradingSettings`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const CreateRetestExam = async (data) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/CreateRetest`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};
export const getRevalStudentList = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/ReetstData/?CourseId=${id}&type=Revaluation`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postRevalStudentList = async (id, paylaod) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/ReetstData/?CourseId=${id}&type=Revaluation`
  );
  const res = await axiosInstance.post(`${path}${query}`, paylaod);
  return res && res.data ? res.data : null;
};

export const getRetestStudentList = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/RetestRevaluationDetails?type=Retest`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

export const postRetestStudentList = async (id, paylaod) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/ReetstData/?CourseId=${id}&type=Retest`
  );
  const res = await axiosInstance.post(`${path}${query}`, paylaod);
  return res && res.data ? res.data : null;
};

export const getRevalQuestionRequestStudentList = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/RequestAnswer/?CourseId=${id}&type=Revaluation&RequestForAnswer=Requested`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const getquestionpaper = async (id) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/QuestionPaper/?QuestionPaperId=${id}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};
export const postapiquestionpaper = async (paylaod) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(`/services/apexrest/QuestionPaper/`);
  const res = await axiosInstance.post(`${path}${query}`, paylaod);
  return res && res.data ? res.data : null;
};
export const postRevalQuestionRequestStudentList = async (id, paylaod) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/RequestAnswer/?CourseId=${id}&type=Revaluation&RequestForAnswer=Requested`
  );
  const res = await axiosInstance.post(`${path}${query}`, paylaod);
  return res && res.data ? res.data : null;
};

// export const getRetestStudentList = async (id) => {
//   const path = `${appConfig.integrationUrl}/sf/data?api=`;
//   const query = encodeURIComponent(
//     `/services/apexrest/ReetstData/?CourseId=${id}&type=Retest`
//   );
//   const res = await axiosInstance.get(`${path}${query}`);
//   return res && res.data ? res.data : null;
// };

// For Seating Plan

export const seatingPlanUpdate = async (paylaod) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/updateExamSeatAllocation`
  );
  const res = await axiosInstance.post(`${path}${query}`, paylaod);
  return res && res.data ? res.data : null;
};

export const seatingPlanStudentDataList = async (examId) => {
  const path = `${appConfig.integrationUrl}/sf/data?api=`;
  const query = encodeURIComponent(
    `/services/apexrest/ExamSeatAllocation/?examId=${examId}`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};

// NEW API's
export const getFilterData = async () => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/pageFilters`
  )}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};
export const getSectionData = async (termid) => {
  const path = `sf/exam/section/${termid}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};
export const getExamSetupData = async (termid) => {
  const path = `sf/exam/getExamSetup/${termid}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};
export const postExamSetupData = async (paylaod) => {
  const path = `${appConfig.integrationUrl}/sf/exam/update/exam`;
  const res = await axiosInstance.patch(`${path}`, paylaod);
  return res && res.data ? res.data : null;
};
export const getStudentStatusData = async (termid, section, courseid) => {
  const path = `sf/exam/studentStatus?termid=${termid}&sectionid=${section}&courseid=${courseid}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};
export const getQuestionPaperData = async (examid) => {
  const path = `sf/exam/questionPaper/${examid}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getInvigilationData = async (examid) => {
  const path = `sf/exam/invigilatorList/${examid}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getFacultyData = async () => {
  const path = `sf/exam/facultyData`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getRoomsAvailable = async (examId) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/seatingPlan/retrieve/roomsAvailable?examId=${examId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getSeatingArrangementData = async (examId) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/seatingPlan/retrieve/seatingArrangement?examId=${examId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const updateInvigilation = async (payload) => {
  const path = `sf/exam/update/invigilation`;
  const res = await axiosInstance.patch(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const updateEvaluation = async (payload) => {
  const path = `sf/exam/update/evaluation`;
  const res = await axiosInstance.patch(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};

export const getEvaluation = async (examId) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `services/apexrest/evaluator/retrieve/Evaluators?examId=${examId}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const postStudentData = async (paylaod) => {
  const path = `${appConfig.integrationUrl}/sf/exam/update/eligibily`;
  const res = await axiosInstance.patch(`${path}`, paylaod);
  return res && res.data ? res.data : null;
};

export const postPublishExams = async (paylaod) => {
  const path = `${appConfig.integrationUrl}/sf/exam/update/publish`;
  const res = await axiosInstance.patch(`${path}`, paylaod);
  return res && res.data ? res.data : null;
};

export const getContentVersion = async (id) => {
  const path = `sf/exam/contentVersion/${id}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getContentVersionDoc = async (id) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/seatingPlan/retrieve/document?docid=${id}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getSectionsViaExamId = async (id) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/seatingPlan/retrieve/sections?examId=${id}`
  )}`;
  const res = await axiosInstance.get(`${appConfig.integrationUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const postQuestionPaperData = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/exam/update/question`;
  const res = await axiosInstance.patch(`${path}`, payload);
  return res && res.data ? res.data : null;
};

export const postQuestionPaperPublish = async (payload) => {
  const path = `${appConfig.integrationUrl}/sf/exam/update/QPPublish`;
  const res = await axiosInstance.patch(`${path}`, payload);
  return res && res.data ? res.data : null;
};

export const getExamFacilites = async (examId) => {
  const path = `${appConfig.integrationUrl}/sf/exam/facilities?examId=${examId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postSeatingPlan = async (payload) => {
  const path = `salesforce?endpoint=${encodeURIComponent(
    `/services/apexrest/seatingPlan/save`
  )}`;
  const res = await axiosInstance.post(
    `${appConfig.integrationUrl}/${path}`,
    payload
  );
  return res && res.data ? res.data : null;
};
